export default "__VITE_ASSET__217f65e1__"